/**
 * Convert legacy Asset UI callback parameter to AO1 object
 *
 * @param {object} asset     - callback parameter from Asset UI
 * @param {object} [context] - AO1 context
 * @returns {object}           AO1 object
 */
export const assetToAO1 = (asset, context = {}) => {
  const {
    _meta: {mimeType, locale, size},
    assetId,
    url,
  } = asset;

  return {
    _type: 'ao1',
    assetId,
    attr: {},
    context,
    url,
    _meta: {
      aspectRatio: '1:1', // legacy Asset UI doesn't provide this
      locale,
      mimeType,
      size,
    },
  };
};

/**
 * Convert legacy asset to AO1 object
 *
 * @param {object} asset     - callback parameter from Asset UI
 * @returns {object}           AO1 object
 */
export const convertToAO1 = (asset) => {
  if (asset && asset?.url) {
    return asset;
  }

  return {
    _type: 'ao1',
    assetId: asset?.uuid,
    attr: {},
    context: {},
    url: convertLegacyPlaceholderUrl(asset?.download),
    _meta: {
      aspectRatio: '1:1', // legacy Asset UI doesn't provide this
      locale: asset?.attr?.locale,
      mimeType: asset?.attr?.mimeType,
      size: asset?.attr?.size,
    },
  };
};


export const convertLegacyPlaceholderUrl = (url) => {
  if (!url || !url.includes('via.placeholder.com')) { 
    return url;
  }

  const match = url.match(/via\.placeholder\.com\/(\d+x\d+)\??(.*)/);

  if (!match) { 
    return url;
  }

  const size = match[1];
  const textQuery = match[2].replace('?', '').replace(/ /g, '+');

  return `https://dummyimage.com/${size}/cccccc/000000&${textQuery}`;
}